import React from "react";
import ProcedureAssignmentSettingRulesetPresenter from "../common/presenter";
import { useProcedureAssignmentSettingRuleSetCreate } from "./hooks";
import { useFeatureFlag_EnableAssignmentSettingRuleset } from "../../../../../feature-flags";
import { Redirect } from "react-router-dom";
import { SmartApplyR } from "../../route";
import { NewContentsHeader } from "./contentsHeader";

const ProcedureAssignmentSettingRulesetNewContainer: React.FC = () => {
  const hookResult = useProcedureAssignmentSettingRuleSetCreate();

  if (!useFeatureFlag_EnableAssignmentSettingRuleset()) {
    return <Redirect to={SmartApplyR.Applications.link({})} />;
  }

  const contentsHeader = (
    <NewContentsHeader
      onSave={hookResult.handleSave}
      onCancel={hookResult.handleCancel}
    />
  );

  return (
    <ProcedureAssignmentSettingRulesetPresenter
      {...hookResult}
      contentsHeader={contentsHeader}
    />
  );
};

export default ProcedureAssignmentSettingRulesetNewContainer;
